/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AS as AS,
  rec_JSXRuntime as JSXRuntime,
  rec_OS as OS,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_kS as kS,
} from "../../runtime/index.jsx";
export function EditorMenciones(e) {
  let t = (0, ReactCompiler.c)(20),
    {
      value: n,
      onChange: r,
      miembros: i,
      onMenciones: a,
      placeholder: o,
      rows: s,
      className: c,
      disabled: l,
    } = e,
    u;
  t[0] === i
    ? (u = t[1])
    : ((u = i === void 0 ? [] : i), (t[0] = i), (t[1] = u));
  let f = u,
    p = s === void 0 ? 3 : s,
    m = c === void 0 ? `` : c,
    h = l !== void 0 && l,
    _ = (0, React.useRef)(null),
    [v, y] = (0, React.useState)(null),
    b = n || ``,
    x;
  if (t[2] !== f || t[3] !== b) {
    let e;
    (t[5] === b
      ? (e = t[6])
      : ((e = (e) => e.usuarioNombre && b.includes(`@` + e.usuarioNombre)),
        (t[5] = b),
        (t[6] = e)),
      (x = f.filter(e).map(AS)),
      (t[2] = f),
      (t[3] = b),
      (t[4] = x));
  } else x = t[4];
  let S = x,
    C;
  t[7] !== f || t[8] !== r || t[9] !== a
    ? ((C = function (e) {
        (r(e),
          a?.(
            f
              .filter(
                (t) => t.usuarioNombre && e.includes(`@` + t.usuarioNombre),
              )
              .map(kS),
          ));
      }),
      (t[7] = f),
      (t[8] = r),
      (t[9] = a),
      (t[10] = C))
    : (C = t[10]);
  let w = C,
    T;
  t[11] === w
    ? (T = t[12])
    : ((T = function (e) {
        let t = e.target.value;
        w(t);
        let n = e.target.selectionStart,
          r = t.slice(0, n).match(/@([\p{L}\p{N} .'-]{0,30})$/u);
        y(r ? r[1] : null);
      }),
      (t[11] = w),
      (t[12] = T));
  let E = T,
    D;
  bb0: {
    if (v == null) {
      let e;
      (t[13] === Symbol.for(`react.memo_cache_sentinel`)
        ? ((e = []), (t[13] = e))
        : (e = t[13]),
        (D = e));
      break bb0;
    }
    let e;
    if (t[14] !== f || t[15] !== v) {
      let n = v.trim().toLowerCase();
      ((e = f
        .filter(OS)
        .filter((e) => !n || e.usuarioNombre.toLowerCase().includes(n))
        .slice(0, 6)),
        (t[14] = f),
        (t[15] = v),
        (t[16] = e));
    } else e = t[16];
    D = e;
  }
  let O = D,
    k = function (e) {
      let t = _.current,
        r = t.selectionStart,
        i = (n || ``).slice(0, r),
        a = (n || ``).slice(r),
        o = i.replace(
          /@([\p{L}\p{N} .'-]{0,30})$/u,
          `@` + e.usuarioNombre + ` `,
        ),
        s = o + a;
      (w(s),
        y(null),
        requestAnimationFrame(() => {
          (t.focus(), (t.selectionStart = t.selectionEnd = o.length));
        }));
    },
    A;
  t[17] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((A = () => setTimeout(() => y(null), 150)), (t[17] = A))
    : (A = t[17]);
  let j;
  return (
    t[18] === S.length
      ? (j = t[19])
      : ((j = S.length > 0 && (
          <p
            className={`mt-1 text-[11px] text-(--text)`}
            children={[
              `Menciona a `,
              S.length,
              ` `,
              S.length === 1 ? `persona` : `personas`,
            ]}
          />
        )),
        (t[18] = S.length),
        (t[19] = j)),
    (
      <div
        className={`relative`}
        children={[
          <textarea
            ref={_}
            value={n}
            onChange={E}
            onBlur={A}
            placeholder={o}
            rows={p}
            disabled={h}
            className={`${m} disabled:cursor-not-allowed disabled:opacity-60`}
          />,
          O.length > 0 && (
            <ul
              className={`animar-entrada absolute z-30 mt-1 max-h-48 w-64 overflow-y-auto rounded-2xl border border-(--border) bg-(--bg) shadow-2xl`}
              children={O.map((e) => (
                <li
                  key={e.usuarioId}
                  children={
                    <button
                      type={`button`}
                      onMouseDown={(t) => {
                        (t.preventDefault(), k(e));
                      }}
                      className={`w-full px-3 py-2 text-left text-sm text-(--text-h) transition hover:bg-(--accent-bg)`}
                      children={[`@`, e.usuarioNombre]}
                    />
                  }
                />
              ))}
            />
          ),
          j,
        ]}
      />
    )
  );
}
